'use client'

import { useState } from 'react'

import type { TypeProvider } from '@lib/types'
import ProviderInsuranceModal from '@components/fad/provider-insurance-modal'
import { Button, Typography } from '@shc/ui'
import useAnalytics from '@hooks/use-analytics'

export interface ProviderInsurancePlansProps {
  provider: TypeProvider
}

const ProviderInsurancePlans = ({ provider }: ProviderInsurancePlansProps) => {
  const hasMultipleInsurance =
    Array.isArray(provider.insurances_facet) && provider.insurances_facet.filter((ins: string) => ins.split(' > ').length > 1).length > 1
  const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false)

  const { track: trackSnowplow } = useAnalytics()
  const openAcceptedPlansModal = () => {
    setIsInsuranceModalOpen(true)
    trackSnowplow({
      event: { name: 'modal_open', data: {} },
      contexts: [
        { name: 'modal', data: { modal_name: 'InsuranceModal' } },
        {
          name: 'provider',
          data: {
            provider_id: provider.id ?? -1,
            provider_name: provider.name_formatted ?? '',
          },
        },
      ],
    })
  }

  return (
    <>
      <Typography variant="h2">Insurance plans accepted</Typography>
      <Typography className="pt-8">
        {provider.name_formatted_with_degrees},
        {hasMultipleInsurance
          ? ` accepts ${provider.insurances_facet?.filter((ins: string) => ins.split(' > ').length > 1)?.length} health insurance plans.`
          : ' accepts only 1 insurance plan.'}
      </Typography>
      <div className="pt-8">
        <Button
          onClick={openAcceptedPlansModal}
          variant="outlined"
          width="auto"
          className="basis-1/2">
          {hasMultipleInsurance ? 'View accepted plans' : 'View accepted plan'}
        </Button>
      </div>

      <ProviderInsuranceModal
        provider={provider}
        isModalOpen={isInsuranceModalOpen}
        setIsModalOpen={setIsInsuranceModalOpen}
      />
    </>
  )
}

export default ProviderInsurancePlans
